import { StringEnum } from "../../utils/string-enum.js";
import { Type } from "@sinclair/typebox";

//#region src/shared/bricks/props/text.ts
function fontSize(options = {}) {
	return StringEnum([
		"inherit",
		"text-xs",
		"text-sm",
		"text-base",
		"text-lg",
		"text-xl"
	], {
		enumNames: [
			"Same as parent",
			"Extra small",
			"Small",
			"Medium",
			"Large",
			"Extra large"
		],
		default: "inherit",
		title: "Font size",
		"ui:styleId": "styles:fontSize",
		"ui:field": "enum",
		"ui:display": "select",
		...options
	});
}
function fontSizeXL(options = {}) {
	return StringEnum([
		"inherit",
		"text-xs",
		"text-sm",
		"text-base",
		"text-lg",
		"text-xl",
		"text-2xl",
		"text-3xl",
		"text-4xl",
		"text-5xl",
		"text-6xl",
		"text-7xl"
	], {
		enumNames: [
			"Same as parent",
			"Extra small",
			"Small",
			"Medium",
			"Large",
			"Extra large",
			"Extra large (2x)",
			"Extra large (3x)",
			"Extra large (4x)",
			"Extra large (5x)",
			"Extra large (6x)",
			"Extra large (7x)"
		],
		default: "inherit",
		title: "Font size",
		"ui:styleId": "styles:fontSize",
		"ui:field": "enum",
		"ui:display": "select",
		...options
	});
}
function textContent({ title = "Text", default: defaults, showInSettings, disableSizing = false, disableAlignment = false,...rest } = {}) {
	return Type.String({
		title,
		description: "Text content. Can contain basic HTML tags like `<strong>`, `<em>`, `<br>` and `<a>` as well as `<p>` and `<span>` and lists <ul> <ol> <li>.",
		default: defaults ?? "My text",
		"ui:disable-sizing": disableSizing,
		"ui:disable-alignment": disableAlignment,
		...rest,
		"ui:field": showInSettings ? "string" : "hidden"
	});
}

//#endregion
export { fontSize, fontSizeXL, textContent };
//# sourceMappingURL=text.js.map